import { render } from "./manageVehicle.vue?vue&type=template&id=29f243cf"
import script from "./manageVehicle.vue?vue&type=script&lang=js"
export * from "./manageVehicle.vue?vue&type=script&lang=js"

import "./manageVehicle.vue?vue&type=style&index=0&id=29f243cf&lang=scss"

import exportComponent from "C:\\Users\\DELL\\source\\repos\\project0810frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])